import "./NavBar.css";

const Banner = () => {
  return (
    <div id="bannerimg">
      <div id="centering" className="straatnaam-outer">
        <div  className="straatnaam-xl">
          StraatnaamNFTs
        </div>
      </div>
    </div>
  );
};

export default Banner;
